import { Container, Row, Col, Image } from "react-bootstrap";
import ScreenShortOne from "../../assests/images/manage-my-nonprofit/screen-short-1.webp";
import ScreenShortTwo from "../../assests/images/manage-my-nonprofit/screen-short-2.webp";
import ScreenShortThree from "../../assests/images/manage-my-nonprofit/screen-short-3.webp";
import ReviewSerch from "../../components/common/reviewSerchBox";
import {
    NormalUserSection,
    NormalUserContentBox,
    NormalUserText,
    FindNonprofitSection,
    FindNonprofitText,
    NonprofitWrap,
    NonprofitBox,
    NonprofitCounterBox,
    NonprofitNumber,
    NonprofitText,
    NonprofitBoxImage,
    NonprofitForm,
} from "./manageMyNonprofitStyle"
import MetaComponent from "../../components/common/metaComponent";

const ManageNonprofitNormalUser = () => {
    return (
        <>
            <MetaComponent
                keywords=""
                description=""
                ogTitle=""
                ogDescription=""
                ogUrl=""
                ogImage="https://static.wixstatic.com/media/196996_3096a2e2829f492e8495c525c961782d%7Emv2.jpg/v1/fit/w_2500,h_1330,al_c/196996_3096a2e2829f492e8495c525c961782d%7Emv2.jpg"
            />
            <NormalUserSection>
                <Container className='cont-w'>
                    <Row>
                        <Col sm="12">
                            {/* <NormalUserContentBox>
                                <NormalUserText>
                                    Thanks for registering at GreatNonprofits. You still need to claim your organization by finding it and clicking the claim button. If your organization is unlisted you can also add it. Please contact us if you have any questions.
                                </NormalUserText>
                            </NormalUserContentBox>
                            <NormalUserContentBox className="blue-box-background">Search using your organization's name, EIN is the most accurate way to find your nonprofit profile.</NormalUserContentBox> */}
                        </Col>
                    </Row>
                </Container>
            </NormalUserSection>

            <FindNonprofitSection>
                <Container className="cont-w">
                    <Row>
                        <Col lg="12">
                            <FindNonprofitText>Find A Nonprofit</FindNonprofitText>
                        </Col>
                    </Row>

                    <Row>
                        <Col sm="12">
                            <NonprofitWrap>
                                <NonprofitBox className="non-profit-odd">
                                    <NonprofitCounterBox>
                                        <NonprofitNumber>01</NonprofitNumber>
                                        <NonprofitText>Review and donate to nonprofits such as museums, animal shelters, youth programs and more!</NonprofitText>
                                    </NonprofitCounterBox>
                                    <NonprofitBoxImage>
                                        <Image src={ScreenShortOne} alt="Screen Short One" />
                                    </NonprofitBoxImage>
                                </NonprofitBox>


                                <NonprofitBox className="non-profit-even">
                                    <NonprofitCounterBox>
                                        <NonprofitNumber>02</NonprofitNumber>
                                        <NonprofitText>GreatNonprofits is your single destination for nonprofit giving.</NonprofitText>
                                    </NonprofitCounterBox>
                                    <NonprofitBoxImage>
                                        <Image src={ScreenShortTwo} alt="Screen Short Two" />
                                    </NonprofitBoxImage>
                                </NonprofitBox>

                                <NonprofitBox className="non-profit-odd">
                                    <NonprofitCounterBox>
                                        <NonprofitNumber>03</NonprofitNumber>
                                        <NonprofitText>Give to your favorite nonprofits quickly and easily and track all your charitable giving in one place for easy tax preparation.</NonprofitText>
                                    </NonprofitCounterBox>
                                    <NonprofitBoxImage>
                                        <Image src={ScreenShortThree} alt="Screen Short Three" />
                                    </NonprofitBoxImage>
                                </NonprofitBox>

                                <NonprofitBox>
                                    <NonprofitCounterBox>
                                        <NonprofitNumber>04</NonprofitNumber>
                                        <NonprofitText>Find a Nonprofit Using Organization, City, State and Zipcode</NonprofitText>
                                    </NonprofitCounterBox>
                                    <NonprofitForm>
                                        <ReviewSerch />
                                    </NonprofitForm>
                                </NonprofitBox>

                            </NonprofitWrap>
                        </Col>
                    </Row>

                </Container>
            </FindNonprofitSection>

        </>
    );
}

export default ManageNonprofitNormalUser;

